export default "__VITE_ASSET__oIBYLzuz__"